import "@fontsource/archivo/300.css";
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fontsource/archivo/800.css";
import { themeVariables } from "../constants/tokens.js";
import charts from "./charts.js";
import components from "./components/index.js";
import gradients from "./gradients.js";
import palette from "./palette.js";
import { shadows } from "../constants/shadows.js";
import typography from "./typography.js";
import { markdownReplacements } from "./components/markdown.js";
const {
  color,
  sizes,
  fonts
} = themeVariables;
const defaultTheme = {
  // move this to constants or a higher level spacing prop
  spacing: 4,
  // Default Theme Options
  palette,
  typography,
  boxShadows: shadows,
  // custom vars
  gradients,
  charts,
  components,
  fonts,
  colors: color,
  sizes,
  // Custom Theme replacements
  markdownReplacements,
  zIndex: {
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  }
};
export {
  defaultTheme as default
};
